module.exports = __webpack_public_path__ + "static/media/device1.f47fb275.png";